import React, { useEffect } from 'react'
import { useCylinder } from '@react-three/cannon'
import { MeshReflectorMaterial } from '@react-three/drei';
import useStore from '../hooks/Store';

export const Field = (props) => {
  const speed = 0.7;
  const height = 0.02;
  const segmentsCntPhysics = 9;
  const segmentsCntView = 16;

  const { position = [0, 1.6, 0], rotation, radius = .87 } = props;

  const { countdown } = useStore();

  const [ref, api] = useCylinder(() => ({
    mass: 0,
    position,
    rotation,
    args: [radius, radius, height, segmentsCntPhysics],
    type: "Static"
  }), null, [position, rotation, radius, height, segmentsCntPhysics]);

  useEffect(() => {
    api.angularVelocity.set(0, speed, 0)
  })

  return (
    <group ref={ref}>
      <mesh receiveShadow position={[0, height / 2 + 0.001, 0]} rotation={[-Math.PI / 2, 0, 0.2]}>
        <circleGeometry args={[radius, segmentsCntView]} />
        <MeshReflectorMaterial
          color={countdown !== 0 ? 0x7070d0 : 0x8080c0}
          resolution={256}
          blur={[100, 500]}
          mirror={0.3}
          roughness={0.1}
        />
      </mesh>
    </group>
  )
}

export default Field;